<template>
  <div class="panel pt-1 w-100" :class="{ 'panel-with-footer': !isLoading }">
    <div class="panel-body-lg pb-3">
      <news-feed
        :title="'<h2>News based on your interests<h2>'"
        :posts="posts"
        :topics="topics"
        :is-loading="isLoading"
        :is-errored="isErrored"
        :is-full-page="false"
        :enable-edit-interests="true"
        @interestsSaved="initializeNewsByInterests"
      />
    </div>
    <div class="panel-footer-wrapper" v-if="!isLoading && !isErrored">
      <panel-footer
        :text="'View all news'"
        :router-link-to="{ path: 'news-by-interests' }"
        :event-name="'News by interest panel view all clicked'"
      />
    </div>
  </div>
</template>

<script>
import api from "@/api";
import * as CONSTANTS from "@/store/constants";
import NewsFeed from "./NewsFeed";
import PanelFooter from "../panels/PanelFooter";

export default {
  name: "news-by-interests",
  components: {
    NewsFeed,
    PanelFooter,
  },
  data() {
    return {
      CONSTANTS,
      isLoading: true,
      isErrored: false,
      posts: null,
      topics: null,
      queryConfig: {
        size: 3,
        offset: 0,
      },
    };
  },
  created() {
    this.initializeNewsByInterests();
  },
  methods: {
    async initializeNewsByInterests() {
      this.isLoading = true;
      try {
        let newsRes = await api.getNewsByInterests(
          this.queryConfig.offset,
          this.queryConfig.size
        );
        let news = newsRes.data.data.newsByInterest.news.news;
        this.posts = news;
        this.topics = newsRes.data.data.newsByInterest.topics;

      } catch (e) {
        this.isErrored = true;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.panel {
  min-height: 500px;
  position: relative;
}
.panel-with-footer {
  padding-bottom: 80px;
  flex-grow: 1;
}
.panel-footer-wrapper {
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/homebase/newsByInterests/NewsByInterests.vue